
export default () => ({
	client: [],
	clients: null,
	clientsStatistics: null,
	clientStatistics: null,
	meta: {},
	clientOrdersProductsMeta: {},
	clientOrdersMeta: {},
	orders: [],
	ordersOld: [],
	ordersOldMeta: {},
	ordersMeta: {},
	editClientForm: { departmentClient: false, locked: false },
	searchFilters: {},
	ordersSearchFilters: {},
	loading: {
		clients: false
	}
})
